module.exports = __webpack_public_path__ + "img/papaterra.f8d08221.png";